// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select {
  margin-bottom: 42px;
  display: flex;
  align-items: center;
  padding-left: 24px;
  white-space: nowrap;
}

.custom-select__label {
  margin-right: 16px;
}

.custom-select .css-b62m3t-container {
  width: 100%;
  max-width: 238px;
}

.custom-select .css-b62m3t-container .css-1s2u09g-control .css-319lph-ValueContainer {
  padding-left: 16px;
}

.custom-select .css-b62m3t-container .css-1s2u09g-control .css-1hb7zxy-IndicatorsContainer .css-1okebmr-indicatorSeparator {
  display: none;
}

.custom-select .css-b62m3t-container .css-1pahdxg-control .css-319lph-ValueContainer {
  padding-left: 16px;
}

.custom-select .css-b62m3t-container .css-1pahdxg-control .css-1hb7zxy-IndicatorsContainer .css-1okebmr-indicatorSeparator {
  display: none !important;
}

.custom-table .MuiPaper-root {
  box-shadow: unset;
}

.custom-table .MuiPaper-root .MuiTableContainer-root .MuiTable-root .MuiTableHead-root {
  position: relative;
}

.custom-table .MuiPaper-root .MuiTableContainer-root .MuiTable-root .MuiTableHead-root .MuiTableRow-root {
  white-space: nowrap;
}

.custom-table .MuiPaper-root .MuiTableContainer-root .MuiTable-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root {
  border: unset;
  color: #999999;
}

.custom-table .MuiPaper-root .MuiTableContainer-root .MuiTable-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root:last-child .MuiButtonBase-root {
  padding-left: 20px;
}

.custom-table .MuiPaper-root .MuiTableContainer-root .MuiTable-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root:nth-child(1) {
  padding-left: 24px;
}

.custom-table .MuiPaper-root .MuiTableContainer-root .MuiTable-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root:nth-child(1) .MuiButtonBase-root {
  padding-left: 11px;
}

.custom-table .MuiPaper-root .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root {
  font-weight: 500;
  border: unset;
}

.custom-table .MuiPaper-root .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root:last-child {
  padding-left: 20px;
}

.custom-table .activeHeadCell svg {
  color: #24a3ff !important;
}

.custom-pagination {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-bottom: 60px;
}

.custom-pagination ul li {
  display: flex;
  align-items: center;
}

.custom-pagination ul li .Mui-selected {
  background-color: #ffffff;
  color: #292d32;
  font-weight: bold;
}

.custom-pagination ul li .Mui-selected:hover {
  background-color: #ff0009;
}

.custom-pagination ul li .Mui-disabled {
  opacity: unset;
  background: #ffffff !important;
}

.custom-pagination ul li .Mui-disabled svg {
  color: #292d32 !important;
}

.custom-pagination ul li button {
  padding: 8px;
  background: #ffffff;
  font-weight: 400;
  font-size: 16px;
  color: gray;
  margin: unset;
  border-radius: unset;
}

.custom-pagination ul li button:hover {
  background: #ff0009;
  color: #ffffff;
}

.custom-pagination ul li:first-child {
  transition: 300ms;
  transition-timing-function: linear;
  margin-right: 8px;
}

.custom-pagination ul li:first-child:hover {
  transform: translateX(-5px);
}

.custom-pagination ul li:first-child button {
  background: #ff0009;
  border-radius: 8px;
  padding: unset;
}

.custom-pagination ul li:first-child button svg {
  font-size: 18px;
  color: #ffffff;
}

.custom-pagination ul li:first-child .arrow-disabled {
  background: #ffffff;
  cursor: unset;
}

.custom-pagination ul li:first-child .arrow-disabled svg {
  stroke: #292d32;
  cursor: unset;
}

.custom-pagination ul li:first-child .arrow-active {
  background: #ff0009;
}

.custom-pagination ul li:first-child .arrow-active svg {
  stroke: #ffffff;
}

.custom-pagination ul li:nth-child(2) {
  display: flex;
  align-items: center;
}

.custom-pagination ul li:nth-child(2) button {
  padding: 8px;
  border-radius: 8px 0 0 8px;
}

.custom-pagination ul li:nth-last-child(2) button {
  border-radius: 0 8px 8px 0;
}

.custom-pagination ul li:last-child {
  transition: 300ms;
  transition-timing-function: linear;
  margin-left: 8px;
}

.custom-pagination ul li:last-child:hover {
  transform: translateX(5px);
}

.custom-pagination ul li:last-child button {
  background: #ff0009;
  border-radius: 8px;
  padding: unset;
}

.custom-pagination ul li:last-child button svg {
  font-size: 18px;
  color: #ffffff;
}

.custom-pagination ul li:last-child .arrow-disabled {
  background: #ffffff;
  cursor: unset;
}

.custom-pagination ul li:last-child .arrow-disabled svg {
  stroke: #292d32;
  cursor: unset;
}

.custom-pagination ul li:last-child .arrow-active {
  background: #ff0009;
}

.custom-pagination ul li:last-child .arrow-active svg {
  stroke: #ffffff;
}

.edit-button {
  background: none;
  margin-left: 8px;
}

.edit-button svg {
  color: orange;
}

.barcode {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.barcode__text {
  color: #ff0009;
  text-align: center;
}

.dropdown-menu {
  display: none;
  position: absolute;
  background: #eaf6ff;
  width: 181px;
  min-height: 50px;
  padding: 16px;
  transform: translateY(-10px);
  border: unset;
}

.dropdown-menu__title {
  display: none;
  text-align: center;
}

.dropdown-menu__item {
  display: flex;
  gap: 10px;
  flex-direction: column;
  justify-content: space-between;
}

.dropdown-menu__button:nth-child(2) {
  margin-top: 10px;
}

.dropdown-menu__button button {
  width: 100%;
  background: #ffffff;
  color: red;
  border-radius: 8px;
  padding: 5px 10px;
  border: 1px solid red;
  white-space: nowrap;
}

.dropdown-menu__button .button-red {
  background: red;
  color: #ffffff;
}

@media only screen and (max-width: 992px) {
  .custom-select {
    flex-direction: column;
    align-items: flex-start;
  }
  .custom-select__label {
    margin-bottom: 8px;
  }
}

@media only screen and (max-width: 768px) {
  .dropdown-number {
    display: none;
  }
  .dropdown-menu__title {
    display: block;
  }
}

@media only screen and (max-width: 576px) {
  .custom-select {
    padding: 0 24px;
  }
  .custom-select .css-b62m3t-container {
    max-width: unset;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/home/components/styles/style.scss","webpack://./src/modules/home/components/styles/style.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EAGnB,aAAY;ECGJ,mBAAmB;EDD3B,kBAAA;EACE,mBAAkB;ACGtB;;ADVA;EAUI,kBAAW;ACIf;;AAEA;EDhBA,WAAA;EAcQ,gBAAc;ACKtB;;ADnBA;EAkBU,kBAAa;ACKvB;;ADvBA;EAwBQ,aAAY;ACGpB;;AD3BA;EA4BU,kBAAS;ACGnB;;ADIA;EAEI,wBAAiB;ACFrB;;ADAA;EAmCS,iBAAA;AC9BT;;AAEA;ED2BW,kBAAA;ACzBX;;AAEA;EDQc,mBAAc;ACN5B;;ADbA;EAuBkB,aAAY;EACb,cAAA;ACNjB;;AAEA;EDYe,kBAAA;ACVf;;AAEA;EDOiB,kBAAA;ACLjB;;AAEA;EDYc,kBAAa;ACV3B;;AD9BA;EA2CgB,gBAAc;EACf,aAAA;ACTf;;AAEA;EDyBK,kBAAA;ACvBL;;AAEA;ED2BE,yBAAa;ACzBf;;AAEA;EACE,WAAW;ED6BP,aAAa;EATnB,uBAUM;EACE,oBAAkB;ACvB1B;;AAEA;EDyBU,aAAA;EAfV,mBAkBM;ACrBN;;AAEA;EACE,yBAAyB;EDA3B,cAAA;EAsBU,iBAAO;ACnBjB;;ADHA;EA0BQ,yBAAY;ACnBpB;;AAEA;EDqBQ,cAAW;EACX,8BAAa;ACnBrB;;AAEA;EDdA,yBAyBM;ACTN;;AAEA;EACE,YAAY;EDnBd,mBAMI;EAiCI,gBAAY;EACZ,eAAA;EAIA,WAAA;EAyBD,aAAA;EC5CL,oBAAoB;ADzBtB;;AC4BA;EACE,mBAAmB;ED7BrB,cAAA;AC+BA;;AAEA;EAEE,iBAAiB;EDeP,kCAAe;EACf,iBAAc;ACZ1B;;ADvCA;EAyDkB,2BAAK;ACbvB;;AD5CA;EA2DY,mBAAe;EACf,kBAAa;EACd,cAAA;ACXX;;AAEA;EDgBS,eAAA;ECdP,cAAc;ADtDhB;;ACyDA;EACE,mBAAmB;ED1DrB,aAAA;AC4DA;;AAEA;EACE,eAAe;ED/DjB,aAAA;ACiEA;;AAEA;EACE,mBAAmB;ADpErB;;ACuEA;EACE,eAAe;ADxEjB;;AC2EA;EAGE,aAAa;EDaN,mBAAA;ACTT;;AAEA;EDWU,YAAA;EACA,0BAAc;ACTxB;;ADvFA;EAkGY,0BAAe;ACP3B;;AAEA;EDUU,iBAAY;EAMb,kCAAA;ECXP,gBAAgB;ADlGlB;;ACqGA;EAEU,0BAA0B;ADvGpC;;AC0GA;EACE,mBAAmB;ED3GrB,kBAME;EA2GU,cAAQ;ACHpB;;ADWA;EACE,eAAY;EACZ,cAAa;ACRf;;ADMA;EAII,mBAAa;EACd,aAAA;ACNH;;AAEA;EDSE,eAAc;EACd,aAAA;ACPF;;AAEA;EDOE,mBAAQ;ACLV;;AAEA;EACE,eAAe;ADQjB;;ACLA;EDQE,gBAAY;EACZ,gBAAY;ACNd;;AAEA;EDQE,aAAa;ACNf;;ADQE;EAGC,aAAA;EAIM,sBAAI;EAGV,uBAAA;EAIG,mBAAgB;ACNtB;;ADIG;EAMG,cAAW;EACX,kBAAY;ACNlB;;AAEA;EDQM,aAAQ;EACR,kBAAa;EACd,mBAAA;ECNH,YAAY;EDPX,gBAAA;EAgBG,aAAY;EAEb,4BAAA;ECNH,aAAa;ADUf;;ACPA;EACE,aDSa;ECRb,kBDYC;ACXH;;AAEA;EDYA,aAAY;EACV,SAAA;EAIE,sBAAc;ECNR,8BAA8B;ADUxC;;ACPA;EACE,gBDYC;ACXH;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IAIU,sBAAsB;IAGtB,uBAAuB;EACjC;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".custom-select {\n  margin-bottom: 42px;\n  display: flex;\n  align-items: center;\n  padding-left: 24px;\n  white-space: nowrap;\n  &__label {\n    margin-right: 16px;\n  }\n  .css-b62m3t-container {\n    width: 100%;\n    max-width: 238px;\n    .css-1s2u09g-control {\n      .css-319lph-ValueContainer {\n        padding-left: 16px;\n      }\n      .css-1hb7zxy-IndicatorsContainer {\n        .css-1okebmr-indicatorSeparator {\n          display: none;\n        }\n      }\n    }\n    .css-1pahdxg-control {\n      .css-319lph-ValueContainer {\n        padding-left: 16px;\n      }\n      .css-1hb7zxy-IndicatorsContainer {\n        .css-1okebmr-indicatorSeparator {\n          display: none !important;\n        }\n      }\n    }\n  }\n}\n\n.custom-table {\n  .MuiPaper-root {\n    box-shadow: unset;\n    .MuiTableContainer-root {\n      .MuiTable-root {\n        .MuiTableHead-root {\n          position: relative;\n          //&::before {\n          //  content: '';\n          //  width: 94%;\n          //  border-bottom: 1px solid #999999;\n          //  position: absolute;\n          //  top: 25px;\n          //  left: 20px;\n          //}\n          .MuiTableRow-root {\n            white-space: nowrap;\n            .MuiTableCell-root {\n              border: unset;\n              color: #999999;\n\n              &:last-child {\n                .MuiButtonBase-root {\n                  padding-left: 20px;\n                }\n              }\n\n              &:nth-child(1) {\n                padding-left: 24px;\n                .MuiButtonBase-root {\n                  padding-left: 11px;\n                }\n              }\n            }\n          }\n        }\n        .MuiTableBody-root {\n          .MuiTableRow-root {\n            .MuiTableCell-root {\n              font-weight: 500;\n              border: unset;\n\n              &:last-child {\n                padding-left: 20px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // .css-1mxz8qt-MuiPaper-root {\n  //     box-shadow: unset;\n\n  //      .css-10dfkli-MuiTableCell-root:nth-child(1) {\n  //          padding-left: 35px;\n  //      }\n  // }\n  .activeHeadCell {\n    svg {\n      color: #24a3ff !important;\n    }\n  }\n}\n\n.custom-pagination {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  padding-bottom: 60px;\n\n  ul {\n    li {\n      display: flex;\n      align-items: center;\n      .Mui-selected {\n        background-color: #ffffff;\n        color: #292d32;\n        font-weight: bold;\n        &:hover {\n          background-color: #ff0009;\n        }\n      }\n      .Mui-disabled {\n        opacity: unset;\n        background: #ffffff !important;\n        svg {\n          color: #292d32 !important;\n        }\n      }\n      button {\n        padding: 8px;\n        background: #ffffff;\n        font-weight: 400;\n        font-size: 16px;\n        color: gray;\n        margin: unset;\n        border-radius: unset;\n        &:hover {\n          background: #ff0009;\n          color: #ffffff;\n        }\n      }\n      &:first-child {\n        transition: 300ms;\n        transition-timing-function: linear;\n        &:hover {\n          transform: translateX(-5px);\n        }\n        margin-right: 8px;\n        button {\n          background: #ff0009;\n          border-radius: 8px;\n          padding: unset;\n          svg {\n            font-size: 18px;\n            color: #ffffff;\n          }\n        }\n\n        .arrow-disabled {\n          background: #ffffff;\n          cursor: unset;\n          svg {\n            stroke: #292d32;\n            cursor: unset;\n          }\n        }\n        .arrow-active {\n          background: #ff0009;\n          svg {\n            stroke: #ffffff;\n          }\n        }\n      }\n\n      &:nth-child(2) {\n        display: flex;\n        align-items: center;\n        button {\n          padding: 8px;\n          border-radius: 8px 0 0 8px;\n        }\n      }\n\n      &:nth-last-child(2) {\n        button {\n          border-radius: 0 8px 8px 0;\n        }\n      }\n\n      &:last-child {\n        transition: 300ms;\n        transition-timing-function: linear;\n        &:hover {\n          transform: translateX(5px);\n        }\n        margin-left: 8px;\n        button {\n          background: #ff0009;\n          border-radius: 8px;\n          padding: unset;\n          svg {\n            font-size: 18px;\n            color: #ffffff;\n          }\n        }\n        .arrow-disabled {\n          background: #ffffff;\n          cursor: unset;\n          svg {\n            stroke: #292d32;\n            cursor: unset;\n          }\n        }\n        .arrow-active {\n          background: #ff0009;\n          svg {\n            stroke: #ffffff;\n          }\n        }\n      }\n    }\n  }\n}\n\n.edit-button {\n  background: none;\n  margin-left: 8px;\n  svg {\n    color: orange;\n  }\n}\n\n.barcode {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  &__text {\n    color: #ff0009;\n    text-align: center;\n  }\n}\n\n.dropdown-menu {\n  display: none;\n  position: absolute;\n  background: #eaf6ff;\n  width: 181px;\n  min-height: 50px;\n  padding: 16px;\n  transform: translateY(-10px);\n  border: unset;\n\n  &__title {\n    display: none;\n    text-align: center;\n  }\n\n  &__item {\n    display: flex;\n    gap: 10px;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n\n  &__button {\n    &:nth-child(2) {\n      margin-top: 10px;\n    }\n\n    button {\n      width: 100%;\n      background: #ffffff;\n      color: red;\n      border-radius: 8px;\n      padding: 5px 10px;\n      border: 1px solid red;\n      white-space: nowrap;\n    }\n\n    .button-red {\n      background: red;\n      color: #ffffff;\n    }\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .custom-select {\n    flex-direction: column;\n    align-items: flex-start;\n    &__label {\n      margin-bottom: 8px;\n    }\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .dropdown-number {\n    display: none;\n  }\n  .dropdown-menu__title {\n    display: block;\n  }\n}\n\n@media only screen and (max-width: 576px) {\n  .custom-select {\n    padding: 0 24px;\n    .css-b62m3t-container {\n      max-width: unset;\n    }\n  }\n}\n",".custom-select {\n  margin-bottom: 42px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding-left: 24px;\n  white-space: nowrap;\n}\n\n.custom-select__label {\n  margin-right: 16px;\n}\n\n.custom-select .css-b62m3t-container {\n  width: 100%;\n  max-width: 238px;\n}\n\n.custom-select .css-b62m3t-container .css-1s2u09g-control .css-319lph-ValueContainer {\n  padding-left: 16px;\n}\n\n.custom-select .css-b62m3t-container .css-1s2u09g-control .css-1hb7zxy-IndicatorsContainer .css-1okebmr-indicatorSeparator {\n  display: none;\n}\n\n.custom-select .css-b62m3t-container .css-1pahdxg-control .css-319lph-ValueContainer {\n  padding-left: 16px;\n}\n\n.custom-select .css-b62m3t-container .css-1pahdxg-control .css-1hb7zxy-IndicatorsContainer .css-1okebmr-indicatorSeparator {\n  display: none !important;\n}\n\n.custom-table .MuiPaper-root {\n  -webkit-box-shadow: unset;\n          box-shadow: unset;\n}\n\n.custom-table .MuiPaper-root .MuiTableContainer-root .MuiTable-root .MuiTableHead-root {\n  position: relative;\n}\n\n.custom-table .MuiPaper-root .MuiTableContainer-root .MuiTable-root .MuiTableHead-root .MuiTableRow-root {\n  white-space: nowrap;\n}\n\n.custom-table .MuiPaper-root .MuiTableContainer-root .MuiTable-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root {\n  border: unset;\n  color: #999999;\n}\n\n.custom-table .MuiPaper-root .MuiTableContainer-root .MuiTable-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root:last-child .MuiButtonBase-root {\n  padding-left: 20px;\n}\n\n.custom-table .MuiPaper-root .MuiTableContainer-root .MuiTable-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root:nth-child(1) {\n  padding-left: 24px;\n}\n\n.custom-table .MuiPaper-root .MuiTableContainer-root .MuiTable-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root:nth-child(1) .MuiButtonBase-root {\n  padding-left: 11px;\n}\n\n.custom-table .MuiPaper-root .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root {\n  font-weight: 500;\n  border: unset;\n}\n\n.custom-table .MuiPaper-root .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root:last-child {\n  padding-left: 20px;\n}\n\n.custom-table .activeHeadCell svg {\n  color: #24a3ff !important;\n}\n\n.custom-pagination {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding-bottom: 60px;\n}\n\n.custom-pagination ul li {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.custom-pagination ul li .Mui-selected {\n  background-color: #ffffff;\n  color: #292d32;\n  font-weight: bold;\n}\n\n.custom-pagination ul li .Mui-selected:hover {\n  background-color: #ff0009;\n}\n\n.custom-pagination ul li .Mui-disabled {\n  opacity: unset;\n  background: #ffffff !important;\n}\n\n.custom-pagination ul li .Mui-disabled svg {\n  color: #292d32 !important;\n}\n\n.custom-pagination ul li button {\n  padding: 8px;\n  background: #ffffff;\n  font-weight: 400;\n  font-size: 16px;\n  color: gray;\n  margin: unset;\n  border-radius: unset;\n}\n\n.custom-pagination ul li button:hover {\n  background: #ff0009;\n  color: #ffffff;\n}\n\n.custom-pagination ul li:first-child {\n  -webkit-transition: 300ms;\n  transition: 300ms;\n  -webkit-transition-timing-function: linear;\n          transition-timing-function: linear;\n  margin-right: 8px;\n}\n\n.custom-pagination ul li:first-child:hover {\n  -webkit-transform: translateX(-5px);\n          transform: translateX(-5px);\n}\n\n.custom-pagination ul li:first-child button {\n  background: #ff0009;\n  border-radius: 8px;\n  padding: unset;\n}\n\n.custom-pagination ul li:first-child button svg {\n  font-size: 18px;\n  color: #ffffff;\n}\n\n.custom-pagination ul li:first-child .arrow-disabled {\n  background: #ffffff;\n  cursor: unset;\n}\n\n.custom-pagination ul li:first-child .arrow-disabled svg {\n  stroke: #292d32;\n  cursor: unset;\n}\n\n.custom-pagination ul li:first-child .arrow-active {\n  background: #ff0009;\n}\n\n.custom-pagination ul li:first-child .arrow-active svg {\n  stroke: #ffffff;\n}\n\n.custom-pagination ul li:nth-child(2) {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.custom-pagination ul li:nth-child(2) button {\n  padding: 8px;\n  border-radius: 8px 0 0 8px;\n}\n\n.custom-pagination ul li:nth-last-child(2) button {\n  border-radius: 0 8px 8px 0;\n}\n\n.custom-pagination ul li:last-child {\n  -webkit-transition: 300ms;\n  transition: 300ms;\n  -webkit-transition-timing-function: linear;\n          transition-timing-function: linear;\n  margin-left: 8px;\n}\n\n.custom-pagination ul li:last-child:hover {\n  -webkit-transform: translateX(5px);\n          transform: translateX(5px);\n}\n\n.custom-pagination ul li:last-child button {\n  background: #ff0009;\n  border-radius: 8px;\n  padding: unset;\n}\n\n.custom-pagination ul li:last-child button svg {\n  font-size: 18px;\n  color: #ffffff;\n}\n\n.custom-pagination ul li:last-child .arrow-disabled {\n  background: #ffffff;\n  cursor: unset;\n}\n\n.custom-pagination ul li:last-child .arrow-disabled svg {\n  stroke: #292d32;\n  cursor: unset;\n}\n\n.custom-pagination ul li:last-child .arrow-active {\n  background: #ff0009;\n}\n\n.custom-pagination ul li:last-child .arrow-active svg {\n  stroke: #ffffff;\n}\n\n.edit-button {\n  background: none;\n  margin-left: 8px;\n}\n\n.edit-button svg {\n  color: orange;\n}\n\n.barcode {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.barcode__text {\n  color: #ff0009;\n  text-align: center;\n}\n\n.dropdown-menu {\n  display: none;\n  position: absolute;\n  background: #eaf6ff;\n  width: 181px;\n  min-height: 50px;\n  padding: 16px;\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  border: unset;\n}\n\n.dropdown-menu__title {\n  display: none;\n  text-align: center;\n}\n\n.dropdown-menu__item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 10px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n\n.dropdown-menu__button:nth-child(2) {\n  margin-top: 10px;\n}\n\n.dropdown-menu__button button {\n  width: 100%;\n  background: #ffffff;\n  color: red;\n  border-radius: 8px;\n  padding: 5px 10px;\n  border: 1px solid red;\n  white-space: nowrap;\n}\n\n.dropdown-menu__button .button-red {\n  background: red;\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 992px) {\n  .custom-select {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n  }\n  .custom-select__label {\n    margin-bottom: 8px;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .dropdown-number {\n    display: none;\n  }\n  .dropdown-menu__title {\n    display: block;\n  }\n}\n\n@media only screen and (max-width: 576px) {\n  .custom-select {\n    padding: 0 24px;\n  }\n  .custom-select .css-b62m3t-container {\n    max-width: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
